<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-mapping-sidebar>
  <app-crud-table body [crudService]="crudService"
                   [transPartKey]="'src-mapping-contract'" [fieldId]="'id'" [fieldName]="'sourceContractCode'"
                   [tableConfig]="tableConfig" [newRecord]="newRecord"
                   [(formRecord)]="formRecord" [formConfig]="formConfig"
                   (dialogFormVisibleChange)="$event?onFormShow():{}"
                   [formLoading]="formLoading"
                   [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                   [writeRoles]="CCRoles.ROLES_MAPPING_WRITE"
                   [prepareForClone]="prepareRecordForClone" [totalRecords]="totalRecords"
  ></app-crud-table>
</app-mapping-sidebar>
